import { CountryEnv, LANGUAGE } from "@type/index";

const _countryEnv: CountryEnv = {
  clientId: process.env.REACT_APP_CLIENT_ID_UK_UQ || "uq.gb.styling-book",
  sbRootId: process.env.REACT_APP_FILTERS_SB_ROOT_ID_UK_UQ || 24126,
  shRootId: process.env.REACT_APP_FILTERS_SH_ROOT_ID_UK_UQ || 24131,
  firebaseApiKey:
    process.env.REACT_APP_FIREBASE_API_KEY_EU_UQ ||
    "AIzaSyDE056gop2EPT3-XkaMwgmebYyxvrAtm5w",
  firebaseProjectId:
    process.env.REACT_APP_FIREBASE_PROJECT_ID_EU_UQ || "fr-stg-ec-frontend",
  firebaseAppId:
    process.env.REACT_APP_FIREBASE_APP_ID_UK_UQ ||
    "1:160978693362:web:c88dc53a7388421f47346b",
  firebaseMeasurementId:
    process.env.REACT_APP_ENV === "staging" ? "G-X16B2STTCS" : "",
  storeDomain: process.env.REACT_APP_STORE_DOMAIN_UQ || "",
  showAboutApp: true,
  showDualPrice: true,
  languages: [LANGUAGE.EN]
};

export default _countryEnv;
